import { render, staticRenderFns } from "./modal_preins.vue?vue&type=template&id=678e19b6&scoped=true"
import script from "./modal_preins.vue?vue&type=script&lang=js"
export * from "./modal_preins.vue?vue&type=script&lang=js"
import style0 from "./modal_preins.vue?vue&type=style&index=0&id=678e19b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e19b6",
  null
  
)

export default component.exports